import { updateObject } from './../../utils/utility';

const initialState = {
    orderListDRS: [],
    orderList: [],
    selectedOrderData: null,
    orderDetailsCallComplete: false,
    totalOrder: 0,
    currentPage: 0,
    totalPage: 0,
    receivedByCarrier: 0,
    ordered: 0,
    labelCreated: 0,
    cancelled: 0,
    cancelRequestSent: 0,
    monthDiff: 0,
    completed: 0,
    inProgress: 0,
    totalPlaced: 0,
    orderIds: [],
    orderSummaryCallComplete: false,
    listRefreshed: false,
    apiFetchError: false,
    searchConfig: null,
    totalElements: 0,
    pageNumber: 0,
    totalPages: 0,
    companyList: [],
    isAFReportDeleteValid: null
};

const setListRefreshed = (state = initialState) => {
    return updateObject(state, {
        listRefreshed: false
    });
}
const setOrderIds = (state = initialState, action) => {
    return updateObject(state, {
        orderIds: action.payload.orderIds
    });
}

const setOrdersData = (state = initialState, action) => {
    const { orderList, totalOrder, currentPage, totalPage } = action.payload.searchResultData;
    return updateObject(state, {
        orderList: orderList,
        totalOrder: totalOrder,
        currentPage: currentPage,
        totalPage: totalPage,
        listRefreshed: true,
        apiFetchError: false,
        searchConfig: action.payload.searchConfig
    }
    );
}

const setAFRepostDeleteValid = (state = initialState, action) => {
    return updateObject(state, {
        isAFReportDeleteValid: action.payload
    }
    );
}

const setOrdersListData = (state = initialState, action) => {
    const { orderList, totalElements, pageNumber, totalPages } = action.payload;
    return updateObject(state, {
        orderList,
        totalElements,
        pageNumber,
        totalPages
    });
}

const setOrdersSummary = (state = initialState, action) => {
    const { receivedByCarrier, labelCreated, ordered, cancelled, cancelRequestSent, completed, inProgress, totalPlaced, monthDiff } = action.payload;
    return updateObject(state, {
        receivedByCarrier: receivedByCarrier ? parseInt(receivedByCarrier) : 0,
        labelCreated: labelCreated ? parseInt(labelCreated) : 0,
        ordered: ordered ? parseInt(ordered) : 0,
        cancelled: cancelled ? parseInt(cancelled) : 0,
        cancelRequestSent: cancelRequestSent ? parseInt(cancelRequestSent) : 0,
        completed: completed ? parseInt(completed) : 0,
        inProgress: inProgress ? parseInt(inProgress) : 0,
        totalPlaced: totalPlaced ? parseInt(totalPlaced) : 0,
        monthDiff: monthDiff ? parseInt(monthDiff) : 0,
        orderSummaryCallComplete: true
    }
    );
}

const setOrderSummaryCallComplete = (state = initialState, action) => {
    return updateObject(state, {
        orderSummaryCallComplete: action.data
    });
}

const setAPIFetchError = (state = initialState, action) => {
    return updateObject(state, {
        apiFetchError: action.data,
        listRefreshed: action.data
    });
}

const setSelectedOrderData = (state = initialState, action) => {

    const updatedState = updateObject(state, {
        selectedOrderData: action.payload,
        orderDetailsCallComplete: true
    });
    return updatedState;
}

const resetSelectedOrderData = (state = initialState) => {
    const updatedState = updateObject(state, {
        selectedOrderData: null,
        orderDetailsCallComplete: false
    });
    return updatedState;
}

const setOrderDetailsCallComplete = (state = initialState, action) => {
    return updateObject(state, {
        orderDetailsCallComplete: action.data
    });
}

const setSearchConfig = (state = initialState, action) => {
    return updateObject(state, {
        searchConfig: action.data
    });
}

const setCTOrders = (state = {}, action) => {
    return updateObject(state, { ctOrdersForDashboard: action.payload });
}

const setDCOrders = (state = {}, action) => {
    return updateObject(state, { dcOrdersForDashboard: action.payload });
}
const setIDCDashboardValues = (state = {}, action) => {
    return updateObject(state, { idcDashboardValues: action.payload });
}

const setFinancialList = (state = initialState, action) => {
    const { financialList, totalElements, pageNumber, totalPages, companyList } = action.payload;
    return updateObject(state, {
        financialList,
        totalElements,
        pageNumber,
        totalPages,
        companyList
    }
    );
};

const updateVendorFinancialdata = (state = initialState, action) => {
    const { value, columnName, rowIndex } = action;
    const { financialList } = state;
    financialList[rowIndex] = { ...financialList[rowIndex], [columnName]: value };
    return updateObject(state, { financialList });
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_ORDER_LIST") {
        return setOrdersData(state, action);
    }
    if (action.type === "SET_ORDER_IDS") {
        return setOrderIds(state, action);
    }
    if (action.type === "SET_ORDERS_SUMMARY") {
        return setOrdersSummary(state, action);
    }
    if (action.type === "SET_ORDER_LIST_REFRESHED") {
        return setListRefreshed(state);
    }
    if (action.type === "SET_ORDER_SUMMARY_CALL_COMPLETE") {
        return setOrderSummaryCallComplete(state, action);
    }
    if (action.type === "SET_API_FETCH_ERROR") {
        return setAPIFetchError(state, action);
    }
    if (action.type === "SET_SELECTED_ORDER_DATA") {
        return setSelectedOrderData(state, action);
    }
    if (action.type === "RESET_SELECTED_ORDER_DATA") {
        return resetSelectedOrderData(state);
    }
    if (action.type === "SET_ORDER_DETAILS_CALL_COMPLETE") {
        return setOrderDetailsCallComplete(state, action);
    }
    if (action.type === "SET_SEARCH_CONFIG") {
        return setSearchConfig(state, action);
    }
    if (action.type === "SET_ORDER_LIST_DATA") {
        return setOrdersListData(state, action);
    }
    if (action.type === "SET_ORDERS_FOR_CT_DASHBOARD") {
        return setCTOrders(state, action);
    }
    if (action.type === "SET_ORDERS_FOR_DC_DASHBOARD") {
        return setDCOrders(state, action);
    }
    if (action.type === "SET_VALUES_FOR_IDC_DASHBOARD") {
        return setIDCDashboardValues(state, action);
    }
    if (action.type === "SET_VENDOR_FINANCIAL_LIST") {
        return setFinancialList(state, action);
    }
    if (action.type === "UPDATE_VENDOR_FINANCIAL_DATA") {
        return updateVendorFinancialdata(state, action);
    }
    if (action.type === "SET_AF_REPORT_DELETE_VALID") {
        return setAFRepostDeleteValid(state, action);
    }
    return state;
}

export default reducer;
